import HeaderTitle from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import { LpBox } from 'Constants/styles';
import { useState } from 'react';

import FailedPayouts from './FailedPayouts/FailedPayouts';
import MerchantPayoutStatus from './MerchantPayoutStatus/TogglePayoutStatus';
import MultipleMerchantPayoutStatus from './MultipleMerchantPayoutStatus';
import PayoutManualPayment from './PayoutManualPayment';
import PayoutsDisabledMerchants from './PayoutsDisabledMerchants/PayoutsDisabledMerchants';
import { BlueBtn, Flex } from './styles';

const Payouts = () => {
  const [showPayoutManualPaymentModal, setShowPayoutManualPaymentModal] = useState<boolean>(false);
  const [showMultipleMerchantPayoutStatusModal, setShowMultipleMerchantPayoutStatusModal] = useState<boolean>(false);

  return (
    <div className="mb-4">
      <HeaderTitle title="Payouts" />
      <Content>
        <LpBox>
          <h3>Administer Payouts</h3>
          <Flex>
            <BlueBtn onClick={() => setShowPayoutManualPaymentModal(true)}>Mark payout as manually paid</BlueBtn>
          </Flex>
          <Flex>
            <BlueBtn onClick={() => setShowMultipleMerchantPayoutStatusModal(true)}>Enable/Disable payouts</BlueBtn>
          </Flex>
        </LpBox>
        <PayoutManualPayment showModal={showPayoutManualPaymentModal} setShowModal={setShowPayoutManualPaymentModal} />
        <LpBox>
          <FailedPayouts />
        </LpBox>
        <LpBox>
          <PayoutsDisabledMerchants />
        </LpBox>
        <LpBox>
          <MerchantPayoutStatus />
        </LpBox>
        <MultipleMerchantPayoutStatus
          showModal={showMultipleMerchantPayoutStatusModal}
          setShowModal={setShowMultipleMerchantPayoutStatusModal}
        />
      </Content>
    </div>
  );
};

export default Payouts;
